import classes from './ToggleBtn.module.css';

const ToggleBtn = (props) => {
  const { attribute, classList = [] } = props;
  const className = `${classes.ToggleBtn} ${classList
    .map((item) => classes[item])
    .join(' ')}`;

  return (
    <label htmlFor={attribute.id} className={className}>
      <input
        type='checkbox'
        {...attribute}
        className={classes['ToggleBtn__Input']}
      />
    </label>
  );
};

export default ToggleBtn;
